import mitt from 'mitt';

type Events = {
  /** Clic sur un agent dans le canvas Pixi → ouvre le détail React */
  'agent:click': { agentId: string };
  /** Clic sur une salle dans le canvas Pixi → zoom / filtre */
  'room:click': { roomId: string };
  /** Le moteur de simulation a fait un tick */
  'sim:tick': { tick: number };
  /** Un agent a besoin d'une action humaine */
  'agent:needs_action': { agentId: string; taskId: string };
};

export const bus = mitt<Events>();
